module.exports = __webpack_public_path__ + "img/1115158151.594042b9.jpg";